module.exports = __webpack_public_path__ + "img/je.e1e91251.svg";